exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-custom-badge[data-v-bdda1ea4] {\n  margin-left: 5px;\n}\n.hideTab[data-v-bdda1ea4] {\n  display: none;\n}\n", ""]);

// exports
